import styled from 'styled-components';
import { Divider } from '@common/components/Divider/Divider';
import { media } from 'styled-bootstrap-grid';
import { FormStepSectionWrapper } from '@common/features/DynamicPackagesConfigurationWizardNew/FormSteps/FormSteps.styles';

export const SpaSelectionWrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 74px;
  top: 86px;
  background-color: ${({ theme }) => theme.defaultColors.white};
  padding: 0 20px;
  overflow-y: auto;
  justify-content: center;
`;
export const SpaItemGridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media screen and (min-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: 850px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (min-width: 1280px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const SpaItemText = styled.div`
  padding: 20px;
  color: #666;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
`;

export const ItemWrapper = styled.article<{ noImage?: boolean }>`
  display: grid;
  grid-template-columns: ${({ noImage }) => (noImage ? '1fr' : '1fr auto')};
  gap: ${({ noImage }) => (noImage ? '0' : '100px')};
  width: 100%;
  background-color: #ffffff;
  border-radius: 3px;
  overflow: hidden;
  padding: 1.5rem;
  border: ${({ theme }) => `1px solid ${theme.greyColors['grey-20']}`};
  margin-bottom: 1.5rem;
`;

export const SectionDescription = styled.div`
  display: block;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  line-height: 22px;
  margin-bottom: 20px;
`;

export const SelectNumberText = styled.div`
  display: block;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  line-height: 22px;
  font-weight: 600;
  @media screen and (min-width: 768px) {
    margin-top: 1rem;
    margin-bottom: -1.5rem;
  }
`;
interface BackgroundWrapperProps {
  isFullDim: boolean;
  customHeight?: string;
}

export const SpaImageWrapper = styled.div<BackgroundWrapperProps>`
  position: relative;
  height: 200px;
  width: 250px;
  @media screen and (max-width: 600px) {
    /* height: 200px; */
    width: 250px;
  }
`;

export const SpaImage = styled.div<{ url: string }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 1;
  background-size: cover;
  background-position: center center;
  background-image: ${({ url }) => `url(${url})`};
  border-radius: 5px;
`;

export const SpaTypeTitle = styled.h2`
  margin-bottom: 1rem !important;
`;

export const SpaImageWrapperMobile = styled.div<BackgroundWrapperProps>`
  position: relative;
  height: 300px;
  width: 100%;
  margin-bottom: 10px;
`;

export const SpaImageMobile = styled.div<{ url: string }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 1;
  background-size: cover;
  background-position: center center;
  background-image: ${({ url }) => `url(${url})`};
  border-radius: 5px;
`;

export const OptionDivider = styled(Divider)`
  margin: 20px 0;
`;

export const SpaTitleWrapper = styled.div`
  padding-top: 30px;
  margin-bottom: 20px;
  ${media.md`
    margin-bottom: 0;
  `}
  h3 {
    margin: 0;
  }

  @media screen and (max-width: 850px) {
    padding: 0;
    padding-top: 30px;
  }
`;

export const ExperiencesGroupWrapper = styled(FormStepSectionWrapper)`
  border: none;
  padding: 0;

  @media screen and (max-width: 850px) {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    border: 1px solid ${({ theme }) => theme.greyColors['grey-20']};
    border-radius: 5px;
  }
`;
